const quizData = { answers: {}, userData: {} };
const totalQuestions = 10;
const order = ['q1','q2','q3','q4','q5','q6','q7','q8','q9','q10'];
let current = 0;
const histStack = [];

/* ─── Progress bar ───────────────────────────────────────────────────────── */
const quizWrap = document.querySelector('.acme-quiz-wrap');

function setFill(pct) {
  if (quizWrap) quizWrap.style.setProperty('--quiz-fill', pct + '%');
}

function updateProgress() {
  const idx = current;
  const pct = Math.round(((idx + 1) / totalQuestions) * 100);
  document.getElementById('qNum').textContent = Math.min(idx + 1, totalQuestions);
  document.getElementById('dotPctNum').textContent = pct;
  setFill(pct);
  const marker = document.getElementById('dotPct');
  if (marker) marker.style.left = Math.max(5, Math.min(95, pct)) + '%';
  document.querySelectorAll('[data-back]').forEach(b => {
    b.toggleAttribute('disabled', histStack.length === 0);
  });
}

function showScreen(id) {
  document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
  document.getElementById(id).classList.add('active');
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setTimeout(updateProgress, 40);
}

function goNext() {
  histStack.push(order[current]);
  current++;
  if (current < totalQuestions) {
    showScreen(order[current]);
  } else {
    runLoading();
  }
}

function goBack() {
  if (histStack.length === 0) return;
  const prev = histStack.pop();
  current = order.indexOf(prev);
  showScreen(prev);
}

document.querySelectorAll('[data-back]').forEach(b => b.addEventListener('click', goBack));

/* ─── Q1: Ranking (drag to reorder) ─────────────────────────────────────── */
const rankingItems = [
  'Tacos, burritos, Latin American food',
  'Pasta, Italian dishes',
  'Steak, burgers, beef',
  'Grilled or roasted chicken',
  'Stir-fry, Asian-inspired dishes',
  'Curries, flavorful sauces, Indian food',
  'Soups, stews, cozy meals',
  'Fish, seafood',
  'BBQ, smoked meats',
  'Salads, grain bowls, lighter meals',
  'Comfort food (casseroles, pot roast)',
  'Honestly, a little bit of everything'
];

(function initRanking() {
  const c = document.getElementById('rankingList');
  rankingItems.forEach((item, i) => {
    const d = document.createElement('div');
    d.className = 'rank';
    d.draggable = true;
    d.innerHTML = `<div class="rank-num">${i + 1}</div><span class="lbl">${item}</span><div class="grip"><span></span><span></span><span></span></div>`;
    c.appendChild(d);
  });
  wireRanking();
})();

function wireRanking() {
  const list = document.getElementById('rankingList');
  let dragged = null;

  list.querySelectorAll('.rank').forEach(item => {
    item.addEventListener('dragstart', e => {
      dragged = item;
      setTimeout(() => item.classList.add('dragging'), 0);
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', '');
    });

    item.addEventListener('dragend', () => {
      item.classList.remove('dragging');
      item.classList.add('placed');
      setTimeout(() => item.classList.remove('placed'), 600);
      updateRankNums();
      dragged = null;
    });

    item.addEventListener('dragover', e => {
      e.preventDefault();
      if (!dragged || dragged === item) return;
      const rect = item.getBoundingClientRect();
      const middle = rect.top + rect.height / 2;
      list.insertBefore(dragged, e.clientY < middle ? item : item.nextSibling);
      updateRankNums();
    });
  });
}

function updateRankNums() {
  document.querySelectorAll('.rank').forEach((r, i) => {
    r.querySelector('.rank-num').textContent = i + 1;
  });
}

document.getElementById('q1Next').addEventListener('click', () => {
  quizData.answers.q1 = Array.from(document.querySelectorAll('.rank')).map(r => r.querySelector('.lbl').textContent);
  goNext();
});

/* ─── Single-select questions ────────────────────────────────────────────── */
function wireSingle(screen) {
  const opts = document.querySelectorAll(`#${screen} .option`);
  const submitBtn = document.querySelector(`[data-submit="${screen}"]`);
  opts.forEach(o => {
    o.addEventListener('click', () => {
      opts.forEach(x => x.classList.remove('selected'));
      o.classList.add('selected');
      quizData.answers[screen] = o.dataset.value;
      if (submitBtn) submitBtn.disabled = false;
    });
  });
  if (submitBtn) submitBtn.addEventListener('click', goNext);
}
['q2', 'q6', 'q7', 'q8'].forEach(wireSingle);

/* ─── Checkbox questions ─────────────────────────────────────────────────── */
const checkIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="#FFCF36" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>';

function buildChecks(id, items) {
  const c = document.getElementById(id);
  items.forEach(([val, label]) => {
    const lbl = document.createElement('label');
    lbl.className = 'option check';
    lbl.innerHTML = `<input type="checkbox" value="${val}"><span class="box">${checkIcon}</span><span>${label}</span>`;
    c.appendChild(lbl);
  });
}

buildChecks('q3Opts', [
  ['chicken',  'Chicken (any style)'],
  ['beef',     'Beef or steak'],
  ['pork',     'Pork dishes'],
  ['fish',     'Fish & seafood'],
  ['pasta',    'Pasta, Italian food'],
  ['latin',    'Tacos, burritos, Latin food'],
  ['asian',    'Stir-fry, Asian-inspired'],
  ['indian',   'Curries, Indian-inspired'],
  ['veggies',  'Vegetables, plant-based'],
  ['mix',      'A mix of meats, similar sides'],
  ['whatever', "Whatever's on sale or in the fridge"]
]);

buildChecks('q4Opts', [
  ['grilling',    'Grilling or BBQ'],
  ['roasting',    'Roasting in the oven'],
  ['stovetop',    'Pan / stovetop'],
  ['slowcooker',  'Slow cooker or Instant Pot'],
  ['airfryer',    'Air fryer & other appliances'],
  ['mix',         'A mix of everything']
]);

buildChecks('q5Opts', [
  ['challenging', 'Challenging myself with unique meals'],
  ['boring',      'Making the same meals taste different'],
  ['fast',        'Getting dinner done fast on busy nights'],
  ['healthy',     "Healthy food that actually tastes good"],
  ['impress',     'Cooking something that impresses people'],
  ['scared',      "Not knowing what flavors go together"],
  ['better',      'Just making it taste better than bland'],
  ['off',         "Everything I cook just tastes off"]
]);

buildChecks('q10Opts', [
  ['new',     "I'm new — I'd love to learn to cook in general"],
  ['bbq',     'BBQ meats really well'],
  ['chef',    'Complicated chef-level meals'],
  ['time',    'Time management in the kitchen'],
  ['knife',   'Knife skills'],
  ['meat',    'Cutting & cooking different meats'],
  ['flavor',  'Making meals more flavorful'],
  ['season',  'Seasoning food properly'],
  ['sauce',   'Sauces and marinades from scratch'],
  ['cuisine', 'Cooking cuisines authentically']
]);

function wireChecks(screen) {
  const btn = document.getElementById(screen + 'Next');
  const boxes = document.querySelectorAll(`#${screen} input[type="checkbox"]`);
  boxes.forEach(cb => {
    cb.addEventListener('change', () => {
      cb.closest('.option').classList.toggle('selected', cb.checked);
      btn.disabled = !Array.from(boxes).some(b => b.checked);
    });
  });
  btn.addEventListener('click', () => {
    quizData.answers[screen] = Array.from(boxes).filter(b => b.checked).map(b => b.value);
    goNext();
  });
}
['q3', 'q4', 'q5', 'q10'].forEach(wireChecks);

/* ─── Q9: Slider ─────────────────────────────────────────────────────────── */
const slider = document.getElementById('adventureSlider');
const sv     = document.getElementById('sliderValue');
const sm     = document.getElementById('sliderMood');
const moods  = {
  1:  "I play it safe — keep it simple",
  2:  "I play it safe — keep it simple",
  3:  "I lean toward classic flavors",
  4:  "I'm warming up to new things",
  5:  "I'm a balanced taster",
  6:  "I'm curious and open",
  7:  "I'm pretty adventurous",
  8:  "I'm pretty adventurous",
  9:  "Bring on the bold flavors",
  10: "I'll try anything once"
};

const ticksWrap = document.getElementById('sliderTicks');
for (let i = 1; i <= 10; i++) {
  const s = document.createElement('span');
  s.textContent = i;
  s.dataset.v = i;
  ticksWrap.appendChild(s);
}

function updateSliderUI() {
  const v = parseInt(slider.value, 10);
  sv.textContent = v;
  sm.textContent = moods[v];
  const pct = ((v - 1) / 9) * 100;
  slider.style.setProperty('--v', pct + '%');
  ticksWrap.querySelectorAll('span').forEach(s => {
    s.classList.toggle('active', parseInt(s.dataset.v, 10) === v);
  });
}

slider.addEventListener('input', updateSliderUI);
updateSliderUI();

document.getElementById('q9Next').addEventListener('click', () => {
  quizData.answers.q9 = parseInt(slider.value, 10);
  goNext();
});

/* ─── Loading animation ──────────────────────────────────────────────────── */
function runLoading() {
  showScreen('loading');
  document.getElementById('qNum').textContent = totalQuestions;
  document.getElementById('dotPctNum').textContent = 100;
  setFill(100);
  const marker = document.getElementById('dotPct');
  if (marker) marker.style.left = '95%';

  const steps = document.querySelectorAll('#loadingSteps .loading-step');
  steps.forEach(s => s.classList.remove('active', 'done'));
  steps[0].classList.add('active');
  setTimeout(() => { steps[0].classList.replace('active','done'); steps[1].classList.add('active'); }, 900);
  setTimeout(() => { steps[1].classList.replace('active','done'); steps[2].classList.add('active'); }, 1800);
  setTimeout(() => { steps[2].classList.replace('active','done'); showResults(); }, 2700);
}

/* ─── Recommendation engine ──────────────────────────────────────────────── */
// Scoring model — every question adds points to blends, highest score wins.
// No question acts as a hard exit so all 10 questions influence the result.
function getRecommendation() {
  const { answers } = quizData;
  const S = {
    'Superior Salt Mix': 0,
    'STK Blend':         0,
    'Smoky Maple':       0,
    'Sweet Chipotle':    0,
    'Sage Blend':        0,
    "Lime 'N Lemon":     0
  };
  const add = (blend, pts) => { if (S[blend] !== undefined) S[blend] += pts; };

  // Q1 — ranked foods (1st = 3 pts, 2nd = 2 pts, 3rd = 1 pt)
  const q1Map = {
    'Tacos, burritos, Latin American food':   'Sweet Chipotle',
    'Pasta, Italian dishes':                  'Sage Blend',
    'Steak, burgers, beef':                   'STK Blend',
    'Grilled or roasted chicken':             'Superior Salt Mix',
    'Stir-fry, Asian-inspired dishes':        'STK Blend',
    'Curries, flavorful sauces, Indian food': 'Sweet Chipotle',
    'Soups, stews, cozy meals':               'Superior Salt Mix',
    'Fish, seafood':                          "Lime 'N Lemon",
    'BBQ, smoked meats':                      'Smoky Maple',
    'Salads, grain bowls, lighter meals':     "Lime 'N Lemon",
    'Comfort food (casseroles, pot roast)':   'Superior Salt Mix',
    'Honestly, a little bit of everything':   'Superior Salt Mix'
  };
  if (answers.q1) {
    [3, 2, 1].forEach((pts, i) => {
      const b = q1Map[answers.q1[i]];
      if (b) add(b, pts);
    });
  }

  // Q2 — cooking frequency
  if (answers.q2 === 'daily')    add('Superior Salt Mix', 2);
  if (answers.q2 === 'frequent') add('Superior Salt Mix', 1);
  if (answers.q2 === 'weekend')  add('Smoky Maple', 1);
  if (answers.q2 === 'never')    add('Superior Salt Mix', 1);

  // Q3 — what you cook (multi-select; all selections score, no early exits)
  if (answers.q3) {
    if (answers.q3.includes('chicken'))  add('Superior Salt Mix', 2);
    if (answers.q3.includes('beef'))     add('STK Blend',         2);
    if (answers.q3.includes('pork'))     add('Smoky Maple',       2);
    if (answers.q3.includes('fish'))     add("Lime 'N Lemon",     2);
    if (answers.q3.includes('pasta'))    add('Sage Blend',        2);
    if (answers.q3.includes('latin'))    add('Sweet Chipotle',    2);
    if (answers.q3.includes('asian')) { add('STK Blend', 1); add('Smoky Maple', 1); }
    if (answers.q3.includes('indian'))   add('Sweet Chipotle',    2);
    if (answers.q3.includes('veggies')) { add('Superior Salt Mix', 1); add("Lime 'N Lemon", 1); }
    if (answers.q3.includes('mix'))      add('Superior Salt Mix', 3);
    if (answers.q3.includes('whatever')) add('Superior Salt Mix', 3);
    // Variety bonus — cooking 3+ different things = versatile all-rounder
    if (answers.q3.length >= 3)          add('Superior Salt Mix', 2);
  }

  // Q4 — cooking methods
  if (answers.q4) {
    if (answers.q4.includes('grilling'))    add('Smoky Maple',       3);
    if (answers.q4.includes('roasting'))  { add('Superior Salt Mix', 1); add('Sage Blend', 1); }
    if (answers.q4.includes('stovetop'))  { add('STK Blend', 1);  add('Superior Salt Mix', 1); }
    if (answers.q4.includes('slowcooker')){ add('Superior Salt Mix', 1); add('Smoky Maple', 1); }
    if (answers.q4.includes('airfryer'))    add('Sweet Chipotle',    1);
    if (answers.q4.includes('mix'))         add('Superior Salt Mix', 2);
  }

  // Q5 — cooking goals / pain points
  if (answers.q5) {
    if (answers.q5.includes('challenging'))  add('Sweet Chipotle',    1);
    if (answers.q5.includes('boring'))       add('Sweet Chipotle',    2);
    if (answers.q5.includes('fast'))         add('Superior Salt Mix', 2);
    if (answers.q5.includes('healthy'))    { add("Lime 'N Lemon", 1); add('Superior Salt Mix', 1); }
    if (answers.q5.includes('impress'))    { add('STK Blend', 2); add('Sage Blend', 1); }
    if (answers.q5.includes('scared'))       add('Superior Salt Mix', 3);
    if (answers.q5.includes('better'))       add('Superior Salt Mix', 2);
    if (answers.q5.includes('off'))          add('Superior Salt Mix', 2);
  }

  // Q6 — cook time commitment
  if (answers.q6 === 'quick')    add('Superior Salt Mix', 2);
  if (answers.q6 === 'mealprep') add('Sage Blend',        3);
  if (answers.q6 === 'varies')   add('Superior Salt Mix', 1);

  // Q7 — who you cook for
  if (answers.q7 === 'family') add('Superior Salt Mix', 1);
  if (answers.q7 === 'varies') add('Superior Salt Mix', 1);

  // Q8 — cooking style / risk tolerance
  if (answers.q8 === 'safe')       add('Superior Salt Mix', 2);
  if (answers.q8 === 'easy')       add('Superior Salt Mix', 1);
  if (answers.q8 === 'experiment'){ add("Lime 'N Lemon", 1); add('Sweet Chipotle', 1); }
  if (answers.q8 === 'follow')     add('Superior Salt Mix', 1);
  if (answers.q8 === 'wing')     { add('Sweet Chipotle', 1); add('STK Blend', 1); }

  // Q9 — adventure slider (1–10)
  const adv = answers.q9 || 5;
  if      (adv <= 3) add('Superior Salt Mix', 3);
  else if (adv <= 6) add('Superior Salt Mix', 1);
  else if (adv <= 8) { add('Sweet Chipotle', 1); add('STK Blend', 1); }
  else               { add("Lime 'N Lemon", 2); add('Sweet Chipotle', 1); }

  // Q10 — skills to improve
  if (answers.q10) {
    if (answers.q10.includes('new'))     add('Superior Salt Mix', 2);
    if (answers.q10.includes('bbq'))     add('Smoky Maple',       3);
    if (answers.q10.includes('chef'))  { add('STK Blend', 2); add('Sage Blend', 1); }
    if (answers.q10.includes('time'))    add('Superior Salt Mix', 1);
    if (answers.q10.includes('meat'))  { add('STK Blend', 1); add('Smoky Maple', 1); }
    if (answers.q10.includes('flavor'))  add('Superior Salt Mix', 1);
    if (answers.q10.includes('season'))  add('Superior Salt Mix', 2);
    if (answers.q10.includes('sauce'))   add('Sage Blend',        1);
    if (answers.q10.includes('cuisine')){ add('Sweet Chipotle', 1); add('STK Blend', 1); }
  }

  // Return highest scorer as primary, second-highest as risk pick
  const ranked = Object.entries(S).sort((a, b) => b[1] - a[1]);
  return { blend: ranked[0][0], risk: ranked[1][0] };
}

/* ─── Blend definitions ──────────────────────────────────────────────────── */
const blends = {
  'Superior Salt Mix': {
    tagline:  'Garlic & zesty orange — your everyday seasoning',
    img:      (window.QUIZ_IMAGES && window.QUIZ_IMAGES.superior) || '',
    color:    '#FFCF36',
    textInk:  '#070821',
    invert:   false,
    flavors:  [['Garlic', 'Garlic'], ['Zesty Orange', 'Zesty Orange'], ['Everyday', 'Everyday']],
    reasons:  [
      'Perfect for your cooking frequency and style',
      'Works on everything you\'re making',
      'Garlic and zesty orange — lets ingredients shine',
      'Impossible to mess up — Chef Bob\'s promise'
    ],
    tip:  'Use it on everything. Bob\'s been using it for 30+ years and hasn\'t found something it doesn\'t work on.',
    shop: 'https://acmesaltco.com/products/superior-salt-mix'
  },
  'STK Blend': {
    tagline:  'Garlic, peppers & depth — for steak lovers',
    img:      (window.QUIZ_IMAGES && window.QUIZ_IMAGES.stk) || '',
    color:    '#045542',
    textInk:  '#fff',
    invert:   true,
    flavors:  [['Garlic', 'Garlic'], ['Peppers', 'Peppers'], ['Depth', 'Depth']],
    reasons:  [
      'Specially crafted to enhance rich cuts of beef',
      'Savory herbs and spices with smoky undertones',
      'Perfect for grilling, pan-searing, or broiling',
      'Adds a gourmet touch to every bite'
    ],
    tip:  'Try ½ tsp in 2 cups of bone broth — knock-your-socks-off flavor.',
    shop: 'https://acmesaltco.com/products/stk-blend'
  },
  'Smoky Maple': {
    tagline:  'Sweet, smoky maple — BBQ perfection',
    img:      (window.QUIZ_IMAGES && window.QUIZ_IMAGES.smoky) || '',
    color:    '#E34C18',
    textInk:  '#070821',
    invert:   false,
    flavors:  [['Smoky', 'Smoky'], ['Maple Sweet', 'Maple Sweet'], ['BBQ', 'BBQ']],
    reasons:  [
      'Made for grilling and smoking',
      'Perfect for BBQ, pork, and Asian cooking',
      'Adds smoky flavor even without a smoker',
      'Great for slow-cooked meals'
    ],
    tip:  'Don\'t just use for BBQ — try it on Asian stir-fry or grilled veggies.',
    shop: 'https://acmesaltco.com/products/smoky-maple'
  },
  'Sweet Chipotle': {
    tagline:  'Sweet meets heat — chipotle harmony',
    img:      (window.QUIZ_IMAGES && window.QUIZ_IMAGES.chipotle) || '',
    color:    '#410909',
    textInk:  '#fff',
    invert:   true,
    flavors:  [['Mild Heat', 'Mild Heat'], ['Chipotle', 'Chipotle'], ['Sweet', 'Sweet']],
    reasons:  [
      'Perfect for Latin food and adventurous cooking',
      'Mild heat balanced with sweetness',
      'Breaks you out of boring meal routines',
      'Great on meats, veggies, even popcorn'
    ],
    tip:  'Try it on popcorn. Sounds weird, tastes incredible. Also amazing on mango.',
    shop: 'https://acmesaltco.com/products/sweet-chipotle'
  },
  'Sage Blend': {
    tagline:  'Earthy, herby — Italian-perfect',
    img:      (window.QUIZ_IMAGES && window.QUIZ_IMAGES.sage) || '',
    color:    '#68B79A',
    textInk:  '#070821',
    invert:   false,
    flavors:  [['Sage', 'Sage'], ['Herby', 'Herby'], ['Italian', 'Italian']],
    reasons:  [
      'Perfect for pasta and Italian cooking',
      'Great for meal prep — breakfast sausage!',
      'Earthy sage flavor that\'s comforting',
      'Works beautifully on pork and chicken'
    ],
    tip:  'Mix with ground pork for homemade breakfast sausage. Game changer.',
    shop: 'https://acmesaltco.com/products/sage-blend'
  },
  "Lime 'N Lemon": {
    tagline:  'Bright, zesty — pure citrus',
    img:      (window.QUIZ_IMAGES && window.QUIZ_IMAGES.lime) || '',
    color:    '#056748',
    textInk:  '#fff',
    invert:   true,
    flavors:  [['Citrus', 'Citrus'], ['Bright', 'Bright'], ['Fresh', 'Fresh']],
    reasons:  [
      'Perfect for fish, seafood, and adventurous cooks',
      '100% real citrus — no citric acid',
      'Adds brightness to lighter meals',
      'The fresh flavor you\'ve been looking for'
    ],
    tip:  'Use it on the rim of your glass for mocktails or margaritas. Instant fancy.',
    shop: 'https://acmesaltco.com/products/lime-n-lemon'
  }
};

const riskReasons = {
  'Smoky Maple':      'Take your grill game up a notch with smoky, sweet BBQ flavors.',
  'Sweet Chipotle':   'Add some excitement to your routine with mild heat and bold flavor.',
  "Lime 'N Lemon":   'Try fresh, bright citrus on fish tacos or grilled chicken.',
  'Sage Blend':       'Explore earthy, Italian flavors — perfect for pasta night.',
  'STK Blend':        'Elevate your next steak or stir-fry with restaurant-quality umami.',
  'Superior Salt Mix':'The versatile classic that works on absolutely everything.'
};

function resolveColor(cssVar) {
  if (typeof cssVar === 'string' && cssVar.startsWith('var(')) {
    const name = cssVar.slice(4, -1).trim();
    const el = quizWrap || document.documentElement;
    return getComputedStyle(el).getPropertyValue(name).trim();
  }
  return cssVar;
}

/* ─── Render results ─────────────────────────────────────────────────────── */
function showResults() {
  const rec = getRecommendation();
  const b   = blends[rec.blend];
  const r   = blends[rec.risk];

  const blendColor = resolveColor(b.color);
  const textColor  = b.textInk === '#fff' ? '#fff' : resolveColor(b.textInk);
  const hero = document.getElementById('resultHero');
  hero.style.setProperty('background', blendColor, 'important');
  hero.style.setProperty('color', textColor, 'important');

  document.getElementById('blendName').textContent    = rec.blend;
  document.getElementById('blendTagline').textContent = b.tagline;
  document.getElementById('blendImg').src             = b.img;
  document.getElementById('blendImg').alt             = rec.blend + ' tin';

  const fr = document.getElementById('flavorRow');
  fr.innerHTML = '';
  b.flavors.forEach(([, label]) => {
    const chip = document.createElement('div');
    chip.className   = 'flavor';
    chip.textContent = label;
    fr.appendChild(chip);
  });

  const whyList = document.getElementById('whyList');
  whyList.innerHTML = '';
  b.reasons.forEach(reason => {
    const li = document.createElement('li');
    li.innerHTML = `<span class="check-mark"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span><span>${reason}</span>`;
    whyList.appendChild(li);
  });

  document.getElementById('bobTip').textContent = b.tip;

  const riskColor     = resolveColor(r.color);
  const riskTextColor = r.textInk === '#fff' ? '#fff' : resolveColor(r.textInk);
  const panelRisk  = document.getElementById('panelRisk');
  panelRisk.style.setProperty('background', riskColor, 'important');
  panelRisk.style.setProperty('color', riskTextColor, 'important');
  document.getElementById('riskBlendImg').src          = r.img;
  document.getElementById('riskBlendImg').alt          = rec.risk + ' tin';
  document.getElementById('riskBlendName').textContent  = rec.risk;
  document.getElementById('riskBlendName').style.setProperty('color', riskTextColor, 'important');
  document.getElementById('riskBlendReason').textContent = riskReasons[rec.risk];
  document.getElementById('riskShopBtn').onclick = () => window.open(r.shop, '_blank');

  document.documentElement.style.setProperty('--blend-color', blendColor);

  const shopBtn = document.getElementById('shopBlendBtn');
  shopBtn.onclick = () => window.open(b.shop, '_blank');

  document.getElementById('progressWrap').style.display = 'none';
  showScreen('results');
}


/* ─── Quiz integration (UTM capture + iframe signup + Meta pixels) ────────── */
(function () {

  /* Capture UTM params — first-touch, session-persisted */
  var utm = {};
  try {
    var params = new URLSearchParams(window.location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(function (k) {
      var v = params.get(k);
      if (v) { utm[k] = v; sessionStorage.setItem('quiz_' + k, v); }
      else { var sv = sessionStorage.getItem('quiz_' + k); if (sv) utm[k] = sv; }
    });
  } catch (e) {}
  window.__quizUTM = utm;

  /* Wrap showResults to fire QuizResult pixel */
  var _origShowResults = showResults;
  showResults = function () {
    _origShowResults.apply(this, arguments);
    try {
      var rec = getRecommendation();
      if (typeof fbq === 'function')
        fbq('trackCustom', 'QuizResult_' + (rec.blend || '').replace(/[^a-zA-Z0-9]/g, ''));
    } catch (e) {}
  };

  /* ── Lead form — iframe submission (same pattern as newsletter-popup) ── */
  var LARAVEL_URL = 'https://acme-quiz.brandchy.com/api/quiz/submit';

  var form        = document.getElementById('quiz-lead-form');
  var noteEl      = document.getElementById('quizNote');
  var signupFrame = document.getElementById('quiz-signup-frame');
  var submitBtn   = form ? form.querySelector('[type="submit"]') : null;
  var submitPending  = false;
  var laravelPromise = null;   /* in-flight Laravel request */

  if (!form || !signupFrame) return;

  /* Point native form at the hidden iframe — no page redirect */
  form.setAttribute('target', 'quiz-signup-frame');
  form.setAttribute('novalidate', '');

  function showSuccess() {
    form.style.setProperty('display', 'none', 'important');
    document.getElementById('codeDisplay').style.setProperty('display', 'block', 'important');
  }

  /* iframe load fires when Shopify confirms — show success immediately.
     Laravel is already in-flight in the background (creates code + sends CM email). */
  signupFrame.addEventListener('load', function () {
    if (!submitPending) return;
    submitPending = false;

    var rec = getRecommendation();
    quizData.userData = {
      firstName:  document.getElementById('resultsFirstName').value.trim(),
      email:      document.getElementById('resultsEmail').value.trim(),
      subscribed: true
    };

    showSuccess();

    try {
      if (typeof fbq === 'function') {
        fbq('track', 'Lead');
        fbq('track', 'CompleteRegistration', { content_name: 'Quiz 10% Signup' });
        fbq('trackCustom', 'QuizLead_' + (rec.blend || '').replace(/[^a-zA-Z0-9]/g, ''));
      }
    } catch (e) {}
  });

  form.addEventListener('submit', function (e) {
    var consentBox = document.getElementById('consentBox');
    if (!consentBox || !consentBox.checked) { e.preventDefault(); return; }

    var firstName = document.getElementById('resultsFirstName').value.trim();
    var email     = document.getElementById('resultsEmail').value.trim();
    if (!firstName || !email) { e.preventDefault(); return; }

    var rec = getRecommendation();

    /* Stamp quiz data into Shopify customer note field */
    if (noteEl) {
      noteEl.value = 'Quiz | Blend: ' + rec.blend + ' | Risk: ' + rec.risk
        + (utm.utm_source ? ' | src: ' + utm.utm_source : '');
    }

    /* Fire Laravel API in parallel — stores answers, creates real discount code */
    laravelPromise = fetch(LARAVEL_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName: firstName,
        email:     email,
        blend:     rec.blend  || null,
        riskBlend: rec.risk   || null,
        answers:   quizData.answers,
        utmParams: utm
      })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });

    submitPending = true;
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }
    /* No e.preventDefault() — native submit carries Shopify's CAPTCHA token */
  });

}());

/* ─── Init ───────────────────────────────────────────────────────────────── */
updateProgress();
